var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgClose(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.3876 11.9988L20.4188 3.61756C20.5367 3.47827 20.4376 3.26666 20.2554 3.26666H18.1179C17.992 3.26666 17.8715 3.32291 17.7885 3.41934L11.9894 10.3327L6.19025 3.41934C6.1099 3.32291 5.98936 3.26666 5.86079 3.26666H3.72329C3.54115 3.26666 3.44204 3.47827 3.5599 3.61756L10.5911 11.9988L3.5599 20.3801C3.5335 20.4111 3.51656 20.4491 3.51109 20.4895C3.50563 20.5298 3.51187 20.5709 3.52908 20.6079C3.54628 20.6448 3.57372 20.6761 3.60815 20.6979C3.64257 20.7197 3.68254 20.7312 3.72329 20.7309H5.86079C5.98668 20.7309 6.10722 20.6747 6.19025 20.5783L11.9894 13.6649L17.7885 20.5783C17.8688 20.6747 17.9894 20.7309 18.1179 20.7309H20.2554C20.4376 20.7309 20.5367 20.5193 20.4188 20.3801L13.3876 11.9988Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgClose);
export default __webpack_public_path__ + "static/media/close.e90648a85b46a86b303e8ea5dc66408e.svg";
export { ForwardRef as ReactComponent };